import {
  BookTag,
  GetTagBySlugParams,
  GetTagBySlugRsult,
  SearchTagsParams,
} from '~/api/book/bookTagApiTypes';
import { provider } from '~/api/provider/provider.config';
import { handleRejectedRequest } from '~/api/provider/providerErrors';
import { ApiResponse, RejectedRequest } from '~/api/provider/providerTypes';

const namespace = Symbol('namespace');

export const bookTagApi = {
  [namespace]: '/v1/books/tags',
  async getTagBySlug({ slug }: GetTagBySlugParams) {
    try {
      const response = await provider.get<
      GetTagBySlugRsult | RejectedRequest<GetTagBySlugParams>
      >(`v1/books/getTagBySlug/${slug}`);

      if ('data' in response.data) {
        return response.data;
      }
    } catch (error) {
      return await handleRejectedRequest<void>(error);
    }
  },
  async searchTags(data: SearchTagsParams) {
    try {
      const response = await provider.get<
      ApiResponse<BookTag[], RejectedRequest<void>>
      >(
        `${this[namespace]}/${data.name}`,
      );

      if ('data' in response.data) {
        return response.data;
      }
    } catch (error) {
      return await handleRejectedRequest<void>(error);
    }
  },
  async getMainPageWidgetTags() {
    try {
      const response = await provider.get<
      ApiResponse<BookTag[], RejectedRequest<void>>
      >(`${this[namespace]}/main-page-widget`);

      if ('data' in response.data) {
        return response.data;
      }
    } catch (error) {
      return await handleRejectedRequest<void>(error);
    }
  },
};
